import React, { useState, useEffect } from "react";
import DeleteModal from "../Assets/DeleteModal";
import { TbEdit } from "react-icons/tb";
import { MdDeleteOutline } from "react-icons/md";
import { db } from "../Config/Firebase"; 
import {
  collection,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  setDoc,
} from "firebase/firestore";

const Settings = ({ isSidebarCollapsed }) => {
  const [Purposes, setPurposes] = useState([]);
const [formData, setFormData] = useState({
  diamond: "",
  coinAmount: "",
  
});
  const [editId, setEditId] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

  // Fetch  Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "diamondExchangePlan"));
        const plans = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setPurposes(plans);
      } catch (error) {
        console.error("Error fetching diamondExchangePlan:", error);
      }
    };

    fetchData();
  }, []);

const handleInputChange = (e) => {
  const { name, value} = e.target;

  if (name === "diamond" || name === "coinAmount") {
    if (value === "" || /^[0-9]*\.?[0-9]*$/.test(value)) {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  } else {
    setFormData((prev) => ({ ...prev, [name]: value }));
  }
};



  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    if (editId) {
      // Update existing document by ID 
      const docRef = doc(db, "diamondExchangePlan", editId);
      await updateDoc(docRef, formData);

      setPurposes((prev) =>
        prev.map((item) =>
          item.id === editId ? { ...item, ...formData } : item
        )
      );
    } else {
      
      const ids = Purposes.map((p) => Number(p.id)).filter((n) => !isNaN(n));
      const maxId = ids.length ? Math.max(...ids) : 0;
      const newId = (maxId + 1).toString();
      const label = `Plan ${newId}`;
      
      await setDoc(doc(db, "diamondExchangePlan", newId), { ...formData, label });

      setPurposes((prev) => [...prev, { id: newId, ...formData, label }]);
    }

    setFormData({ diamond: "", coinAmount: "" });
    setEditId(null);
  } catch (error) {
    console.error("Error saving rechargePlan:", error);
  }
};
  const handleEdit = (id) => {
    const purposeToEdit = Purposes.find((p) => p.id === id);
    if (purposeToEdit) {
      setFormData({
        diamond: purposeToEdit.diamond,
        coinAmount: purposeToEdit.coinAmount,
      });
      setEditId(id);
    }
  };

  const cancelEdit = () => {
    setFormData({ diamond: "", coinAmount: ""});
    setEditId(null);
  };

  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setDeleteModalShow(true);
  };

  const confirmDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await deleteDoc(doc(db, "diamondExchangePlan", itemToDelete));
        setPurposes((prev) => prev.filter((item) => item.id !== itemToDelete));
      } catch (error) {
        console.error("Error deleting diamondExchangePlan:", error);
      }
    }
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

  const cancelDelete = () => {
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

  return (
    <div className=" coin-settings-container">
      {/* Form Section */}
      <div className="bg-white p-[1vw]  coin-settings-form-container">
        <div className="text-[20px] font-bold border-b-1 text-gray-600 border-gray-300 pb-[2px]">
          <h1 className="text-gray-600">
            {editId ? "Update Diamond to Coin Exchange" : "Add Diamond to Coin Exchange"}
          </h1>
        </div>
        <form className="bg-white pt-1 rounded-lg" onSubmit={handleSubmit}>
          

          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Diamond *
            </label>
            <input
              name="diamond"
              value={formData.diamond}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter Diamond Amount"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
              min="0"
              step="any"
            />
          </div>
          

          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Coin Amount *
            </label>
            <input
              name="coinAmount"
              value={formData.coinAmount}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter Coin Amount"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
              min="0"
              step="any"
            />
          </div>
          
          


          
          


          <div className="flex items-center gap-2">
            <button
              type="submit"
              className="bg-blue-500 text-sm hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              {editId ? "Update" : "Save"}
            </button>
            {editId && (
              <button
                type="button"
                onClick={cancelEdit}
                className="bg-gray-500 text-sm hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>

      {/* Table */}
      <ul className="w-full coin-settings-display-container">
        <li className="bg-white p-[1vw]">
          <div className="text-[20px] font-bold pb-[10px]">
            <h1>Diamond Exchange Settings </h1>
          </div>
          <section className="flex flex-col justify-center">
            <div className="h-full">
              <div className="w-full bg-white">
                <div className="overflow-x-auto">
                  <table className="table-auto w-full">
                    <thead className="font-semibold uppercase text-white bg-blue-500">
                      <tr className="grid text-xs grid-cols-4">
                        
                        
                        <th className="px-4 py-2 whitespace-nowrap">
                          <div className="font-semibold text-left">#</div>
                        </th>
                        <th className="px-4 py-2 whitespace-nowrap">
                          <div className="font-semibold text-left">Diamond</div>
                        </th>
                        <th className="px-4 py-2 whitespace-nowrap">
                          <div className="font-semibold text-left">Coins</div>
                        </th>
                        <th className="px-4 py-2 whitespace-nowrap">
                          <div className="font-semibold text-center">Action</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-sm divide-y divide-gray-100">
                      {Purposes.length > 0 ? (
                        Purposes.map((log) => (
                          <tr className="grid grid-cols-4" key={log.id}>
                            <td className="px-4 py-2 whitespace-nowrap">
                              <div
                                className={`text-left font-medium text-gray-800 ${
                                  isSidebarCollapsed ? "text-base" : "text-sm"
                                }`}
                              >
                                {log.id || "N/A"}
                              </div>
                            </td>

                            

                            <td className="px-4 py-2 whitespace-nowrap">
                              <div
                                className={`text-left text-gray-800 ${
                                  isSidebarCollapsed ? "text-base" : "text-sm"
                                }`}
                              >
                                {log.diamond || "N/A"}
                              </div>
                            </td>

                            <td className="px-4 py-2 whitespace-nowrap">
                              <div
                                className={`text-left text-gray-800 ${
                                  isSidebarCollapsed ? "text-base" : "text-sm"
                                }`}
                              >
                                {log.coinAmount || "N/A"}
                              </div>
                            </td>

                            <td className="px-4 py-2 whitespace-nowrap">
                              <div className="flex gap-2 justify-center items-center">
                                <button
                                  onClick={() => handleEdit(log.id)}
                                  className={`text-blue-500 hover:text-blue-700 ${
                                    isSidebarCollapsed ? "text-[16px]" : "text-[20px]"
                                  }`}
                                  title="Edit"
                                >
                                  <TbEdit />
                                </button>
                                <button
                                  onClick={() => handleDeleteClick(log.id)}
                                  className={`text-red-500 hover:text-red-700 ${
                                    isSidebarCollapsed ? "text-[16px]" : "text-[20px]"
                                  }`}
                                  title="Delete"
                                >
                                  <MdDeleteOutline />
                                </button>
                              </div>
                            </td>
                          </tr>

                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="p-2 text-center">
                            No Diamond Exchange Details added yet
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </li>
        
      </ul>

      {/* Delete Modal */}
      {deleteModalShow && (
        <DeleteModal
          itemName={Purposes.find((p) => p.id === itemToDelete)?.label || "Purpose"}
          onClose={cancelDelete}
          onDelete={confirmDelete}
        />
      )}
    </div>
  );
};

export default Settings; 